// Modules
import React from 'react'

// Application
import { useActivateHook } from 'hooks'
import { useApp } from 'context'
import { Contact } from 'typings'
import { OutputErrorCode, OutputErrorMsg } from 'constants/index'

// Components
import { SelectContact, SelectContactInitial } from 'components/Presenters/SelectContact'

import { ErrorResponse } from 'apollo-link-error'

interface Props {
    contacts: Contact[]
}

export const SelectContactWrapper: React.VFC<Props> = ({ contacts }) => {
    const { isSubmitting, setSubmitting, createLogin, setContact, nextStep, cpf, password } = useActivateHook()

    const { openToast } = useApp()

    const handleSubmit = async (values: SelectContactInitial) => {
        try {
            setSubmitting(true)
            if (values.contact?.id) {
                await setContact(values.contact)
                const patient = {
                    cpf,
                    password,
                    contactId: values.contact.id,
                }
                await createLogin(patient)
                setSubmitting(false)
                nextStep()
            }
        } catch (err) {
            setSubmitting(false)
            const e: ErrorResponse = err
            if (e.graphQLErrors) {
                const error = e.graphQLErrors[0].extensions?.code
                if (error === OutputErrorCode.PHONEALREADYINUSE || error === OutputErrorCode.EMAILALREADYINUSE) {
                    openToast(OutputErrorMsg.PHONEALREADYINUSE)
                } else {
                    openToast(OutputErrorMsg.GENERICERROR)
                }
            }
        }
    }

    return (
        <SelectContact
            contacts={contacts}
            handleSubmit={handleSubmit}
            initialValues={{ contact: contacts[0] }}
            isSubmitting={isSubmitting}
        />
    )
}
